
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stitch-fix-vs-competitors",
      function () {
        return require("private-next-pages/stitch-fix-vs-competitors/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stitch-fix-vs-competitors"])
      });
    }
  